module.exports = __webpack_public_path__ + "static/media/ztb.87d28f1a.JPG";